import { FILESPACE_CLIENT_QUERY_KEYS } from '@lucidlink/workspacemanagement';
export const FILESPACE_DIRECT_LINK_KEY = FILESPACE_CLIENT_QUERY_KEYS.FsEntryDirectLink;
export const FilespaceDirectLinkKeyFactory = {
    all: () => [FILESPACE_DIRECT_LINK_KEY],
    exact: (fsEntryId, filespaceId) => [
        ...FilespaceDirectLinkKeyFactory.all(),
        filespaceId,
        fsEntryId,
    ],
};
